module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(_vm.canDeleteTopic()) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Изтриване"
    },
    on: {
      "click": function($event) {
        _vm.deleteTopic()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Назад"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.error) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "comments col-md-12",
    attrs: {
      "id": "comments"
    }
  }, [_c('div', {
    staticClass: "topic-title"
  }, [_c('h3', {
    staticClass: "clearfix"
  }, [_vm._v(_vm._s(_vm.topic.title))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "cat-badge",
    style: ('background-color:' + (_vm.topic.section.color || 'black'))
  }), _vm._v(" " + _vm._s(_vm.topic.section.name))])]), _vm._v(" "), _vm._l((_vm.topic.posts), function(item, i) {
    return _c('div', {
      staticClass: "comment mt-10 mb-2 row"
    }, [_c('div', {
      staticClass: "comment-avatar col-md-1 col-sm-2 text-right pr-1"
    }, [_c('c-uavatar', {
      attrs: {
        "familyuser": item.author,
        "show-name": false
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "comment-content col-md-11 col-sm-10"
    }, [_c('h6', {
      staticClass: "comment-meta"
    }, [_c('router-link', {
      staticClass: "text-secondary",
      attrs: {
        "to": item.author ? '/family/' + item.author.family : '#',
        "title": item.author.name
      }
    }, [_vm._v(_vm._s(item.author.name))]), _vm._v(" "), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("▪")]), _vm._v(" "), _c('small', {
      staticClass: "text-muted",
      attrs: {
        "title": _vm._f("prettyDateTime")(item.createdAt)
      }
    }, [_vm._v(_vm._s(_vm._f("fromNowDateTime")(item.createdAt)))]), _vm._v(" "), (item.updatedAt != item.createdAt) ? _c('small', {
      staticClass: "text-muted",
      attrs: {
        "title": _vm._f("fromNowDateTime")(item.updatedAt)
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "comment-body"
    }, [(item.editing && item.text != item.originalText) ? _c('div', {
      staticClass: "alert alert-danger",
      attrs: {
        "role": "alert"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tТова е само преглед; редактирания коментар все още не е записан.\n\t\t\t\t\t\t\t\t\t\t\t"), _c('a', {
      staticClass: "alert-link",
      on: {
        "click": function($event) {
          _vm.sendEdit(item)
        }
      }
    }, [_c('u', [_vm._v("Натиснете тук за да запишете.")])])]) : _vm._e(), _vm._v(" "), _c('vue-markdown', {
      attrs: {
        "source": item.text,
        "html": false
      }
    }), _vm._v(" "), (item.editing) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('label.forum_edit')))]), _vm._v(" "), _c('f-textarea', {
      attrs: {
        "placeholder": "Редактирайте вашия отговор",
        "crows": 10
      },
      model: {
        value: (item.text),
        callback: function($$v) {
          _vm.$set(item, "text", $$v)
        },
        expression: "item.text"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tМоже да форматирате съобщението си като използвате "), _c('a', {
      attrs: {
        "href": "http://commonmark.org/help/",
        "target": "_blank"
      }
    }, [_vm._v("markdown")]), _vm._v(".\n\t\t\t\t\t\t\t\t\t\t\t"), _c('div', {
      staticClass: "text-right"
    }, [_c('button', {
      staticClass: "btn btn-primary mt-0",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toggleEdit(item)
        }
      }
    }, [_vm._v("Отмяна")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary mt-0",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.sendEdit(item)
        }
      }
    }, [_vm._v("Запис")])])], 1) : _vm._e(), _vm._v(" "), _c('section', {
      staticClass: "post-menu-area clearfix"
    }, [_c('nav', {
      staticClass: "post-controls clearfix"
    }, [_c('div', {
      staticClass: "actions"
    }, [(i != 0 && _vm.canDelete(item)) ? _c('button', {
      staticClass: "widget-button btn-flat btn-danger",
      on: {
        "click": function($event) {
          _vm.deletePost(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.canEdit(item)) ? _c('button', {
      staticClass: "widget-button btn-flat btn-primary",
      on: {
        "click": function($event) {
          _vm.toggleEdit(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "widget-button btn-flat btn-info",
      on: {
        "click": function($event) {
          _vm.addQuote(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-reply",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])], 1)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row pt-2"
  }, [_c('div', {
    staticClass: "col-md-1 col-sm-2 text-center pr-1"
  }, [_c('c-uavatar', {
    staticClass: "float-right",
    attrs: {
      "familyuser": _vm.$user.familyUser,
      "show-name": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-11 col-sm-10"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('label.forum_reply')))]), _vm._v(" "), _c('f-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "placeholder": "Напишете вашия отговор",
      "crows": 10,
      "errors": _vm.errorBag.collect('forum_reply')
    },
    model: {
      value: (_vm.pending.text),
      callback: function($$v) {
        _vm.$set(_vm.pending, "text", $$v)
      },
      expression: "pending.text"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\tМоже да форматирате съобщението си като използвате "), _c('a', {
    attrs: {
      "href": "http://commonmark.org/help/",
      "target": "_blank"
    }
  }, [_vm._v("markdown")]), _vm._v(".\n\t\t\t\t\t\t\t\t\t"), _c('button', {
    staticClass: "btn btn btn-primary pull-right mt-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendReply
    }
  }, [_vm._v("Отговор")])], 1)])], 2)])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-danger alert-with-icon text-center"
  }, [_c('h4', [_c('i', {
    staticClass: "fa fa-bell"
  })]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tНямате достъп до тази тема!\n\t\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78df2e42!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/forum/Topic.vue
// module id = 664
// module chunks = 1